import * as React from 'react';
import { SplashState } from '@/state/SplashState';
import { stateSplash } from '@/selectors/selectors';
import { useDispatch, useSelector } from '@/state/store';
import { changeSplash } from '@/actions/splashActions';
import { forwardRef } from 'react';

const InfoButton = forwardRef<HTMLButtonElement>((_, ref) => {
    const dispatch = useDispatch();
    const splashState = useSelector(stateSplash);
    const iconColor = splashState === SplashState.MAIN ? 'orange' : 'inherit';

    return (
        <button
            ref={ref}
            type="button"
            aria-controls="landingpage"
            aria-owns="landingpage"
            arial-label="Informasjon om Vegkart"
            onClick={() => dispatch(changeSplash(SplashState.MAIN))}
            className="c-splash-button o-btn-square"
            title="Informasjon om Vegkart"
        >
            <i
                className="material-icons"
                aria-hidden="true"
                style={{ color: iconColor, position: 'relative' }}
            >
                info
            </i>
        </button>
    );
});
InfoButton.displayName = 'InfoButton';
export { InfoButton };
